import { BetDetail, StringWithSignature } from '@bpos/common/bet-placement';
import { TotalsPrefix } from '@cds/betting-offer';

import { IBetslipState } from '../../../../../base/store/state';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2OptionMarketPick } from '../../../../../core/picks/betslip-v2-option-market-pick';
import { SignedName } from '../../../../../core/picks/signed-name.model';

export const EmptyName = null as unknown as string;
export const EmptyStringWithSignature = undefined as unknown as StringWithSignature;
type TKeys = 'sportName' | 'regionName' | 'leagueName' | 'eventName' | 'marketName' | 'optionName' | 'name';
type TKeyIntersection<T> = keyof T & TKeys;
type TSource<T> = Record<TKeyIntersection<T>, SignedName>;

export function mapTextValueData<T extends TSource<T>>(source: T, key: TKeyIntersection<T>): Pick<BetDetail, 'textValue' | 'altTextValue'> {
    const sourceProp = source[key];

    let altTextValue = EmptyStringWithSignature;
    if (sourceProp.nameAlternate) {
        altTextValue = {
            value: sourceProp.nameAlternate,
            sign: sourceProp.signatureAlternate || '',
        };
    }

    return {
        textValue: {
            value: sourceProp.name,
            sign: sourceProp.signature,
        },
        altTextValue,
    };
}

export function mapTeaserBetOptionName(pick: BetslipV2OptionMarketPick | BetslipV1Pick, optionName: string, state?: IBetslipState) {
    if (!state) {
        return optionName;
    }

    const teaserPick = state.types.teaserBet.picks[pick.id.toString()];
    if (teaserPick) {
        const searchText = teaserPick.oldPoints.toString();
        const newPoints = getTeaserPickNewPoints(state.types.teaserBet.selectedPoints, teaserPick.oldPoints, teaserPick.newPoints, pick.totalsPrefix);
        let replaceText = newPoints.toString();
        if (optionName.includes('-') && newPoints > 0) {
            replaceText = `+${newPoints}`;
        }

        const splitOptionName = optionName.split(' ');
        const originalValue = splitOptionName?.[splitOptionName.length - 1];

        if (originalValue.includes(',')) {
            return optionName.replace(replaceString(searchText), replaceString(replaceText));
        }

        return optionName.replace(searchText, replaceText);
    }

    return optionName;
}

function getTeaserPickNewPoints(teasedPoints: number, oldPoints: number, newPoints: number, totalsPrefix?: TotalsPrefix) {
    if (totalsPrefix === TotalsPrefix.Over) {
        const calculatedNewPoints = oldPoints - teasedPoints;

        if (calculatedNewPoints !== newPoints) {
            return calculatedNewPoints;
        }
    }

    return newPoints;
}

function replaceString(text: string): string {
    return text.replace('.', ',');
}
